
export function filterOptions(option, searchText) {
    const { value } = option;
    const search = searchText.toLowerCase();

    return (
        value.name != "" && value.name.toLowerCase().includes(search) ||
        value.serial_number != "" && value.serial_number.toLowerCase().includes(search) ||
        value.stop_id != "" && value.stop_id.toLowerCase().includes(search) ||
        value.uuid != "" && value.uuid.toLowerCase().includes(search)
    )
}

export function calcDistanceSuffix(device_distance) {

    var method = "m";
    var distance_away = device_distance;

    if (distance_away > 100) {
        distance_away /= 1000;
        method = "km";
    };

    return ({ type: "~", amount: `${distance_away.toFixed(2)}`, method });
}